// Gender-based avatar colors for French first names
const FEMALE_NAMES = new Set([
  'marie','sophie','isabelle','nathalie','céline','celine','anne','julie','claire',
  'laurence','sandrine','valérie','valerie','patricia','sylvie','martine','florence',
  'nicole','christiane','françoise','francoise','monique','jacqueline','denise','nadine',
  'corinne','véronique','veronique','dominique','christine','emilie','émilie','alice',
  'lucie','léa','lea','emma','laura','sarah','camille','manon','chloé','chloe','elena',
  'hélène','helene','caroline','audrey','virginie','séverine','severine','stéphanie',
  'stephanie','vanessa','alexia','jessica','amandine','pauline','marine','elodie',
  'élodie','mathilde','mélanie','melanie','anaïs','anais','charline','noémie','noemie',
  'aurelie','aurélie','charlène','charlene','morgane','cynthia','delphine','muriel',
  'brigitte','bernadette','claudine','ginette','yvette','michèle','michele','odette',
  'suzanne','henriette','simone','renée','renee','colette','marielle','angélique',
  'angelique','mireille','beatrice','astrid','karine','laure','laetitia','amelia',
  'amélia','juliette','margot','inès','ines','fiona','zoe','zoé','victoria','nina',
  'diana','eva','elise','élise','irène','irene','geneviève','genevieve','france',
  'chantal','odile','roselyne','annick','josiane','nadège','nadege','yasmine','samira',
  'fatima','nora','monica','monika','tania','tatiana','olga','vera','ursula',
  'joëlle','joelle','micheline','rosemarie','nelly','manuela','marisa','rosa',
  'rita','lucia','cécile','cecile','agnes','agnès','francine','colette','simonne',
  'thérèse','therese','marcelle','germaine','léonie','leonie','marguerite','jeanne',
  'heloise','héloïse','adèle','adele','maëlle','maelle','ambre','océane','oceana',
  'perrine','victoire','eleonore','éléonore','oriane','orianne',
]);

const NEUTRAL_MALE = new Set([
  'alexandre','baptiste','guillaume','maxime','jerome','jérôme',
  'stephane','stéphane','claude','dominique','camille','charlie',
]);

function normalize(str) {
  return (str || '').toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

export function getAvatarColor(firstName) {
  if (!firstName) return '#5A35FF';
  const n = normalize(firstName);
  if (NEUTRAL_MALE.has(n)) return '#5A35FF';
  if (FEMALE_NAMES.has(n)) return '#E91E8C';
  // heuristic: -ie, -elle, -ine, -ette endings → female
  if (n.endsWith('ie') || n.endsWith('elle') || n.endsWith('ine') || n.endsWith('ette')) return '#E91E8C';
  return '#5A35FF';
}

export function getAvatarStyle(firstName) {
  const color = getAvatarColor(firstName);
  const isFemale = color !== '#5A35FF';
  return {
    background: isFemale
      ? 'linear-gradient(135deg, #E91E8C, #FF6BB0)'
      : 'linear-gradient(135deg, #5A35FF, #7C5CFF)',
  };
}
